var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "singleCinemagraph__section" },
    [
      _vm.modalShow
        ? _c("div", { staticClass: "info-Modal" }, [
            _c("div", { staticClass: "h-vertical-align-container" }, [
              _c("div", {
                staticClass: "modal__close",
                on: {
                  click: function($event) {
                    _vm.overlay()
                  }
                }
              }),
              _c("div", {
                staticClass: "modal__overlay",
                on: {
                  click: function($event) {
                    _vm.overlay()
                  }
                }
              }),
              _c("div", { staticClass: "modal__wrapper" }, [
                _c("div", { staticClass: "modal__object" }, [
                  _c("div", { staticClass: "modal__container" }, [
                    _c("div", { staticClass: "message__container" }, [
                      _vm.success
                        ? _c("div", { staticClass: "message success" }, [
                            _c("p", [_vm._v("Your Flixel was updated.")]),
                            _c("a", {
                              staticClass: "close",
                              on: {
                                click: function($event) {
                                  _vm.overlay()
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm.error
                        ? _c("div", { staticClass: "message error" }, [
                            _c("p", [
                              _vm._v("There was an error updating your Flixel.")
                            ]),
                            _c("a", {
                              staticClass: "close",
                              on: {
                                click: function($event) {
                                  _vm.overlay()
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm.modalDelete
                    ? _c("div", { staticClass: "deleteCinemagraph__modal" }, [
                        _c("h1", [
                          _vm._v(
                            "Are you sure you want to delete this cinemagraph?"
                          )
                        ]),
                        _c("p", [
                          _vm._v("This is a permanent action. No take backs!")
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--red",
                            on: {
                              click: function($event) {
                                _vm.deleteFlixelInvoke(_vm.flixel.hash)
                              }
                            }
                          },
                          [_vm._v("Yes, delete it!")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--white",
                            on: {
                              click: function($event) {
                                _vm.overlay()
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        : _vm._e(),
      _c("single-flixel", { attrs: { flixel: _vm.flixel, resize: "true" } }),
      _vm.loading ? _c("div", { staticClass: "loading__cover" }) : _vm._e(),
      _vm.loading ? _c("div", { staticClass: "loading--full" }) : _vm._e(),
      _c("div", { staticClass: "flixelDetail" }, [
        _c(
          "div",
          { staticClass: "flixelDetail__item flixelDetail__item--social" },
          [_c("social-sharing", { attrs: { flixel: _vm.flixel } })],
          1
        ),
        _c("div", { staticClass: "flixelDetail__item" }, [
          _c("div", { staticClass: "flixelDetail__item--title" }, [
            _vm.flixel.user_avatar
              ? _c("a", { attrs: { href: _vm.flixel.username } }, [
                  _c("img", { attrs: { src: _vm.flixel.user_avatar } })
                ])
              : _vm._e(),
            _c("a", { attrs: { href: _vm.flixel.username } }, [
              _c("h1", [_vm._v(_vm._s(_vm.flixel.username))])
            ])
          ]),
          _vm.flixel.caption
            ? _c("div", { staticClass: "flixelDetail__item--text" }, [
                _c("p", [_vm._v(_vm._s(_vm.flixel.caption))])
              ])
            : _vm._e(),
          _c("div", { staticClass: "flixelDetail__item--text" }, [
            _c("p", { staticClass: "item__date" }, [
              _vm._v(
                "Posted " + _vm._s(_vm._f("date")(_vm.flixel.date_created))
              )
            ])
          ]),
          _vm.isOwner
            ? _c("div", { staticClass: "flixelDetail__item--text" }, [
                _c("h2", [_vm._v("Embed Target URL")]),
                _c("a", { attrs: { href: _vm.flixel.custom_target_link } }, [
                  _vm._v(
                    " " + _vm._s(_vm.flixel.custom_target_link || "No link")
                  )
                ])
              ])
            : _vm._e(),
          _vm.flixel.watermark_url && _vm.isOwner
            ? _c("div", { staticClass: "flixelDetail__item--text" }, [
                _c("h2", [_vm._v("Custom Watermark")]),
                _vm.flixel.watermark_url
                  ? _c("img", {
                      staticClass: "image preview",
                      attrs: { src: _vm.flixel.watermark_url }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm.isOwner
            ? _c(
                "div",
                {
                  staticClass: "flixelDetail__item--text",
                  on: {
                    click: function($event) {
                      _vm.showEditMenu()
                    }
                  }
                },
                [_vm._m(0)]
              )
            : _vm._e()
        ])
      ]),
      _c("aside", { attrs: { id: "flixelEdit" } }, [
        _c("div", { staticClass: "flixelEdit__container" }, [
          _c(
            "form",
            {
              attrs: { name: "update_flixel" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "ui-input" }, [
                _c("div", { staticClass: "ui-input--itemTitle" }, [
                  _c("label", [_vm._v("Caption")]),
                  _c("span", [
                    _vm._v(_vm._s(110 - _vm.editFlixel.caption.length))
                  ])
                ]),
                _c("div", { staticClass: "ui-input--itemContent" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editFlixel.caption,
                        expression: "editFlixel.caption"
                      }
                    ],
                    attrs: {
                      maxlength: "110",
                      placeholder: "Tell us about your cinemagraph."
                    },
                    domProps: { value: _vm.editFlixel.caption },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.editFlixel, "caption", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "ui-input" }, [
                _vm._m(1),
                _c("div", { staticClass: "ui-input--itemContent" }, [
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editFlixel.privacy,
                          expression: "editFlixel.privacy"
                        }
                      ],
                      attrs: { name: "privacy", type: "radio", value: "1" },
                      domProps: {
                        checked: _vm._q(_vm.editFlixel.privacy, "1")
                      },
                      on: {
                        change: function($event) {
                          _vm.$set(_vm.editFlixel, "privacy", "1")
                        }
                      }
                    }),
                    _c("span", [_vm._v("Public")])
                  ]),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editFlixel.privacy,
                          expression: "editFlixel.privacy"
                        }
                      ],
                      attrs: { name: "privacy", type: "radio", value: "2" },
                      domProps: {
                        checked: _vm._q(_vm.editFlixel.privacy, "2")
                      },
                      on: {
                        change: function($event) {
                          _vm.$set(_vm.editFlixel, "privacy", "2")
                        }
                      }
                    }),
                    _c("span", [_vm._v("Shareable")])
                  ]),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editFlixel.privacy,
                          expression: "editFlixel.privacy"
                        }
                      ],
                      attrs: { name: "privacy", type: "radio", value: "3" },
                      domProps: {
                        checked: _vm._q(_vm.editFlixel.privacy, "3")
                      },
                      on: {
                        change: function($event) {
                          _vm.$set(_vm.editFlixel, "privacy", "3")
                        }
                      }
                    }),
                    _c("span", [_vm._v("Private")])
                  ])
                ]),
                _c("hr"),
                _c("div", { staticClass: "ui-input" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "ui-input--itemContent" }, [
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editFlixel.embedable,
                            expression: "editFlixel.embedable"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.editFlixel.embedable)
                            ? _vm._i(_vm.editFlixel.embedable, null) > -1
                            : _vm.editFlixel.embedable
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.editFlixel.embedable,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.editFlixel,
                                    "embedable",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.editFlixel,
                                    "embedable",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.editFlixel, "embedable", $$c)
                            }
                          }
                        }
                      }),
                      _c("span", [_vm._v("Allow others to easily share")])
                    ])
                  ])
                ]),
                _c("hr"),
                _c("div", { staticClass: "ui-input" }, [
                  _vm._m(3),
                  _c("div", { staticClass: "ui-input--itemContent" }, [
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.EmbedTargetURLSelected,
                            expression: "EmbedTargetURLSelected"
                          }
                        ],
                        attrs: { type: "radio", value: "true" },
                        domProps: {
                          checked: _vm._q(_vm.EmbedTargetURLSelected, "true")
                        },
                        on: {
                          click: function($event) {
                            _vm.useDefault()
                          },
                          change: function($event) {
                            _vm.EmbedTargetURLSelected = "true"
                          }
                        }
                      }),
                      _c(
                        "span",
                        {
                          class: {
                            active: _vm.editFlixel.target === _vm.flixel.link
                          }
                        },
                        [_vm._v("Use Default")]
                      )
                    ]),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.EmbedTargetURLSelected,
                            expression: "EmbedTargetURLSelected"
                          }
                        ],
                        attrs: { type: "radio", value: "false" },
                        domProps: {
                          checked: _vm._q(_vm.EmbedTargetURLSelected, "false")
                        },
                        on: {
                          click: function($event) {
                            _vm.noLink()
                          },
                          change: function($event) {
                            _vm.EmbedTargetURLSelected = "false"
                          }
                        }
                      }),
                      _c(
                        "span",
                        { class: { active: _vm.editFlixel.target === "" } },
                        [_vm._v("No Link")]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "ui-input--itemContent" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editFlixel.custom_target_link,
                          expression: "editFlixel.custom_target_link"
                        }
                      ],
                      class: { faded: _vm.editFlixel.target === "" },
                      attrs: {
                        type: "text",
                        placeholder: "http://www.myurl.com"
                      },
                      domProps: { value: _vm.editFlixel.custom_target_link },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.editFlixel,
                            "custom_target_link",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _c("hr"),
                _c("div", { staticClass: "ui-input" }, [
                  _vm._m(4),
                  _c("div", { staticClass: "ui-input--itemContent" }, [
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editFlixel.shareable,
                            expression: "editFlixel.shareable"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.editFlixel.shareable)
                            ? _vm._i(_vm.editFlixel.shareable, null) > -1
                            : _vm.editFlixel.shareable
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.editFlixel.shareable,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.editFlixel,
                                    "shareable",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.editFlixel,
                                    "shareable",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.editFlixel, "shareable", $$c)
                            }
                          }
                        }
                      }),
                      _c("span", [_vm._v("Allow others to easily share")])
                    ])
                  ])
                ]),
                _c("hr")
              ]),
              _c("div", { staticClass: "ui-input" }, [
                _c("div", { staticClass: "ui-input--itemContent" }, [
                  _c("div", { staticClass: "btn__group" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            _vm.showDelete()
                          }
                        }
                      },
                      [
                        _c("button", { staticClass: "btn btn--red" }, [
                          _vm._v("Delete Cinemagraph")
                        ])
                      ]
                    ),
                    _vm.flixel.watermark
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                _vm.deleteWatermark(_vm.flixel.watermark)
                              }
                            }
                          },
                          [
                            _c("button", { staticClass: "btn btn--red" }, [
                              _vm._v("Delete Watermark")
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _c("div", { staticClass: "ui-input ui-input--edit" }, [
                _c("div", { staticClass: "ui-input--itemContent" }, [
                  _c("a", { on: { click: _vm.closeEdit } }, [
                    _c("button", { staticClass: "btn btn--white" }, [
                      _vm._v("Cancel")
                    ])
                  ]),
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.updateFlixelInvoke()
                        }
                      }
                    },
                    [
                      _c("button", { staticClass: "btn btn--black" }, [
                        _vm._v("Save Changes")
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("button", { staticClass: "btn btn__white" }, [_vm._v("Edit")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--itemTitle" }, [
      _c("label", [_vm._v("Privacy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--itemTitle" }, [
      _c("label", [_vm._v("Show Embed")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--itemTitle" }, [
      _c("label", [_vm._v("Embed Target URL")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-input--itemTitle" }, [
      _c("label", [_vm._v("Show Social Sharing")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19268896", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19268896","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Flixel.vue
// module id = null
// module chunks = 